// extracted by mini-css-extract-plugin
export default {"container":"tutorAccrual_container__kMzQe","content":"tutorAccrual_content__k6HBi","card":"tutorAccrual_card__8ABmb"};